import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./FormKontaktneUdaje.scss";

// prop types
import odberatelPropTypes from "../../../propTypes/odberatelPropTypes";

// actions
import * as appHeaderActions from "../../../actions/appHeaderActions";
import * as odberatelActions from "../../../actions/odberatel/odberatelActions";

//components
import withRouter from "../../../coraWebComponents/utils/withRouter";
import ErrorMsg from "../../ErrorMsg";
import Button from "../../../coraWebComponents/buttons/Button";
import Input from "../../../coraWebComponents/forms/Input";
import Tooltip from "../../../coraWebComponents/forms/Tooltip";
import LoadingPanel from "../../../coraWebComponents/LoadingPanel";

// Routes
import Routes from "../../../constants/Routes";

class FormKontaktneUdaje extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  // FORM METHODS
  onSubmitHandle = async (event) => {
    event.preventDefault();
    const { updateOdberatel } = this.props;

    await updateOdberatel({ ...this.state });
    this.props.navigate(Routes.HOME);
  };
  onChange = (name, value) => {
    this.setState({ [name]: value });
  };

  // SYSTEM METHODS
  componentDidMount() {
    const { showAppHeader, isOdberatelPicked, changeHeaderTitle, odberatel } =
      this.props;

    showAppHeader(false);
    changeHeaderTitle("");

    // get only necessary data from 'odberatel' object and set them to state
    if (isOdberatelPicked) {
      this.setState(
        (({ I_ORGAN, NAZOV, EMAIL1, TELEFON, KONTAKT_OSOBA }) => ({
          I_ORGAN,
          NAZOV,
          EMAIL1,
          TELEFON,
          KONTAKT_OSOBA,
        }))(odberatel)
      );
    }
  }
  render() {
    const { isOdberatelPicked, odberatel, isLoading } = this.props;
    const { EMAIL1, NAZOV, TELEFON, KONTAKT_OSOBA, disabled } = this.state;

    const media = window.matchMedia('only screen and (min-width: 768px)');
    const className = media ? "col-6 offset-3 p-0 forWeb" : "col p-0 forMobile";

    return (
      <div className="row m-0">
        {isOdberatelPicked && (
          <>
            <div className={className}>
              <div className="card formular">
                <div className="form-body">
                  <Tooltip>
                    <form
                      className="k-form changeContactData"
                      onSubmit={this.onSubmitHandle}
                    >
                      {/* TITLE */}
                      <div className="card-title">
                        <div>Zmena kontaktných údajov</div>
                      </div>

                      {/* SUBTITLES */}
                      {odberatel && (
                        <div className="card-subtitle">
                          <div className="row m-0">
                            <div className="col-6 label">Odberateľ:</div>
                            <div className="col-6 value">{NAZOV}</div>
                          </div>
                        </div>
                      )}

                      {/* FIELDS */}
                      <p>&nbsp;</p>
                      <div className="k-form-field">
                        <span>{"Email:"}</span>
                        <Input
                          title="Meníte Váš kontaktný email. 
                          Pozor: Toto nie je zmena Vášho prihlasovacieho mena do aplikácie ZIS portál! 
                          Mení sa iba kontaktný mail, ktorý eviduje Váš dodávateľ."
                          name="EMAIL1"
                          type="email"
                          value={EMAIL1}
                          onChange={this.onChange}
                          validationMessage="Nesprávny format mailovej adresy"
                          disabled={isLoading || disabled}
                        />
                      </div>
                      <div className="k-form-field">
                        <span>{"Telefónny kontakt:"}</span>
                        <Input
                          title="Meníte Váš telefónny kontakt."
                          type="tel"
                          name="TELEFON"
                          value={TELEFON}
                          onChange={this.onChange}
                          placeholder="+421999999999"
                          pattern="([+]\d{3}\s\d{3}\s\d{3}\s\d{3}|[0]{2}\d{3}\s\d{3}\s\d{3}\s\d{3})|(^\d{4}\s\d{3}\s\d{3}$)|(^\d{10}$)|([+]\d{12}|[0]{2}\d{12})|([+]\d{2}\s\d{3}\s\d{3}\s\d{4}|[0]{2}\d{2}\s\d{3}\s\d{3}\s\d{4})|([+]\d{2}\s\d{2}\s\d{4}\s\d{4}|[0]{2}\d{2}\s\d{2}\s\d{4}\s\d{4})|([+]\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2}|[0]{2}\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2})|([0]\d{2}.\d{3}\s\d{2}\s\d{2})|([+]\d{3}\s\d{2}.\d{7}|[0]{2}\d{3}\s\d{2}.\d{7})|([0]\d{2}.\d{7}$)"
                          validationMessage="Nesprávny formát telefónneho čísla"
                          disabled={isLoading || disabled}
                        />
                      </div>

                      <div className="k-form-field">
                        <span>{"Kontaktná osoba:"}</span>
                        <Input
                          title="Kontaktná osoba."
                          type="text"
                          name="KONTAKT_OSOBA"
                          value={KONTAKT_OSOBA}
                          onChange={this.onChange}
                          disabled={isLoading || disabled}
                        />
                      </div>

                      {/* SUBMIT BUTTON */}
                      <div className="k-form-field">
                        <Button
                          primary={true}
                          disabled={isLoading || disabled}
                          label="Uložiť"
                          type="submit"
                        />
                      </div>
                    </form>
                  </Tooltip>
                </div>
              </div>
            </div>
            <LoadingPanel isLoading={isLoading} />
          </>
        )}
        {!isOdberatelPicked && <ErrorMsg text="Vyberte odberateľa" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.odberatel.isLoading,
  isOdberatelPicked: state.odberatel.isPicked,
  odberatel: state.odberatel.data,
});

const mapDispatchToProps = (dispatch) => ({
  changeHeaderTitle: (title) =>
    dispatch(appHeaderActions.changeHeaderTitle(title)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
  updateOdberatel: async (data) =>
    await dispatch(odberatelActions.updateOdberatel(data)),
});

FormKontaktneUdaje.propTypes = {
  changeHeaderTitle: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  isOdberatelPicked: PropTypes.bool,
  odberatel: odberatelPropTypes.odberatel,
  showAppHeader: PropTypes.func,
  updateOdberatel: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FormKontaktneUdaje)
);
